import { GridWithGaps } from '@dreamstack/feature-components/src/layout/MainGrid'
import { SimpleMuiButton } from '@dreamstack/feature-components/src/layout/SimpleMuiButton'
import { useTranslation } from '@dreamstack/i18n'
import { ChevronDown } from '@dreamstack/icons/src/icon-components/ChevronDown'
import { ChevronUp } from '@dreamstack/icons/src/icon-components/ChevronUp'
import axios from 'axios'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import { useEffect, useMemo, useState } from 'react'
import { BarGraph, DesktopControls, MobileControls } from './BarGraph'
import { GraphControls } from './GraphControls'
import { LineGraph } from './LineGraph'
import type { BarGraphData } from './Settings'
import { colors } from './Settings'
import { useControlsForBarGraphData } from './useControlsForBarGraphData'

export type Data = {
  preparedDataForSales: {
    id: string
    data: {
      jahr: any
      summe_anzahl: any
    }[]
  }[]
  preparedDataForRevenue: any[]
}

export const HomeOwnershipReport: FunctionComponent<
  React.PropsWithChildren<{}>
> = ({}) => {
  const [data, setData] = useState<Data>()

  useEffect(() => {
    async function fetchData() {
      const response = await axios.get('/api/wer/fetchWerData')
      setData(response.data)
    }
    fetchData()
  }, [])

  const salesGraph: BarGraphData[] = useMemo(() => {
    return map(data?.preparedDataForSales ?? [], (city) => {
      {
        return {
          ...city,
          data: map(city.data, (c) => {
            return { x: c.jahr, y: c.summe_anzahl }
          }),
        }
      }
    })
  }, [data])

  const t = useTranslation()

  const {
    setShowControls,
    setSelectedXValues,
    showControls,
    possibleX,
    selectedXValues,
  } = useControlsForBarGraphData(salesGraph)
  return (
    <div className="space-y-px-64 md:space-y-px-96">
      <GridWithGaps>
        <div className="col-span-full mb-px-32 md:mb-px-80">
          <MobileControls>
            <div className="space-y-px-16">
              <SimpleMuiButton
                onClick={() => {
                  setShowControls(!showControls)
                }}
                color={'primary'}
                variant={'text'}
                endIcon={showControls ? <ChevronUp /> : <ChevronDown />}
              >
                {t('accentro:graphControls.configureControls')}
              </SimpleMuiButton>
              {showControls && (
                <GraphControls
                  possibleValues={possibleX}
                  selectedValues={selectedXValues}
                  setArray={setSelectedXValues}
                  graphControlAllLabel={t('accentro:graphControls.allCities')}
                />
              )}
            </div>
          </MobileControls>
          <DesktopControls>
            <GraphControls
              possibleValues={possibleX}
              selectedValues={selectedXValues}
              setArray={setSelectedXValues}
              graphControlAllLabel={t('accentro:graphControls.allCities')}
            />
          </DesktopControls>
        </div>
        <LineGraph
          hideYControls
          hideXControls
          controledSelectedIdentifiers={selectedXValues}
          graphControlXLabel={t('accentro:graphControls.allCities')}
          graphControlYLabel={t('accentro:graphControls.allCities')}
          data={salesGraph}
          title={t('accentro:graphControls.revenuePerSale')}
          colors={colors}
          marginAxisLeft={70}
        />
      </GridWithGaps>
      <GridWithGaps>
        <BarGraph
          controledSelectedIdentifiers={['2011', '2021']}
          hideYControls
          hideXControls
          graphControlXLabel={t('accentro:graphControls.allCities')}
          graphControlYLabel={t('accentro:graphControls.allCities')}
          data={data?.preparedDataForRevenue}
          colors={colors}
          title={t('accentro:graphControls.totalRevenue')}
          marginAxisLeft={70}
        />
      </GridWithGaps>
    </div>
  )
}
